<template>
  <span
    :class="['badge', 'rounded-pill', 'fw-semibold', pillClass]"
    :title="tooltip || null"
  >
    {{ label }}
  </span>
</template>

<script>
// Strategy → Bootstrap class mapping.  The single source of truth for how a
// strategy is rendered as a pill, reused by both the overall-profile pill and
// the per-index pills.  Keep aligned with the LLM-side StrategyLiteral.
export const STRATEGY_PILL_CLASS = {
  AGGRESSIVE: 'bg-success',
  CONSERVATIVE: 'bg-warning text-dark',
  DEFENSIVE: 'bg-danger',
};

export default {
  name: 'StrategyPill',
  props: {
    label: {
      type: String,
      required: true,
    },
    // One of AGGRESSIVE / CONSERVATIVE / DEFENSIVE, or null/undefined for the
    // neutral fallback colour.
    strategy: {
      type: String,
      default: null,
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  computed: {
    pillClass() {
      return STRATEGY_PILL_CLASS[this.strategy] || 'bg-secondary';
    },
  },
};
</script>
